document.addEventListener('DOMContentLoaded', () => {
  // すでにロード済みならローダー非表示
  if (sessionStorage.getItem('alreadyLoaded')) {
    const loader = document.getElementById('loader')
    if (loader) loader.style.display = 'none'
    // 本体を即表示
    document.body.classList.add('loaded')
  } else {
    // 初回アクセス時：フラグをセットしてアニメーション開始
    sessionStorage.setItem('alreadyLoaded', 'true')
    startLoaderAnimation()
  }
})

function startLoaderAnimation() {
  // ↓ ここに今のロゴアニメーション（マスクの表示・非表示・繰り返しなど）
  // たとえば：
  // new LogoAnimation().start()
}

export default class Loader {
  toggle: boolean
  endFn: (() => void) | null
  maskLoopId: number | null
  minTime: number
  startTime: number

  constructor(config: { endFn?: (() => void) | null; minTime?: number } = {}) {
    this.toggle = false
    this.endFn = config.endFn || null
    this.maskLoopId = null
    this.minTime = config.minTime || 1600 // 最小表示時間（ms）
    this.startTime = 0

    window.addEventListener('load', () => this.loadedEvent())
    setTimeout(() => {
      if (!this.toggle) this.loadEnd()
    }, 7000)
  }

  loadedEvent() {
    const mask = document.getElementById('maskRect')
    const logo = document.getElementById('loaderLogo') as HTMLElement | null

    if (logo) {
      // 初期状態は非表示
      logo.style.opacity = '0'
    }

    if (mask) {
      // マスクループ開始
      this.startMaskLoop(mask, logo)
    }

    setTimeout(() => {
      if (this.toggle) return
      this.loadEnd()
    }, 250)
  }

  startMaskLoop(
    mask: HTMLElement,
    logo: HTMLElement | null,
    config?: { showSpeed?: number; hideSpeed?: number; pauseTime?: number }
  ) {
    let progress = 0
    let phase: 'show' | 'pause' | 'hide' = 'show'

    const showSpeed = config?.showSpeed ?? 0.03
    const hideSpeed = config?.hideSpeed ?? 0.03
    const pauseTime = config?.pauseTime ?? 800

    const animate = () => {
      if (this.toggle) return
      if (logo && logo.style.opacity === '0') logo.style.opacity = '1'

      if (phase === 'show') {
        progress += showSpeed
        if (progress >= 1) {
          progress = 1
          phase = 'pause'
          setTimeout(() => {
            phase = 'hide'
            requestAnimationFrame(animate)
          }, pauseTime)
          return
        }
      } else if (phase === 'hide') {
        progress += hideSpeed
        if (progress >= 1) {
          progress = 0
          phase = 'show'
          if (logo) logo.style.opacity = '0' // 完全に非表示
        }
      }

      mask.setAttribute('width', (progress * 100).toString())
      this.maskLoopId = requestAnimationFrame(animate)
    }

    animate()
  }

  stopMaskLoop() {
    if (this.maskLoopId) cancelAnimationFrame(this.maskLoopId)
    this.maskLoopId = null
  }

  loadEnd() {
    const elapsed = performance.now() - this.startTime
    if (elapsed < this.minTime) {
      setTimeout(() => this.loadEnd(), this.minTime - elapsed)
      return
    }

    this.toggle = true
    this.stopMaskLoop()

    const loaderItem = document.getElementById('loader')
    if (!loaderItem) return
    if (document.body.id === 'preload') {
      document.body.removeAttribute('id')
    }
    loaderItem.classList.add('loadOp')

    const hash = location.hash
    if (hash) {
      const target = document.querySelector(hash)
      const clientRect = target?.getBoundingClientRect()
      if (clientRect) {
        const y = window.scrollY + clientRect.y
        window.scrollTo({ top: y, behavior: 'instant' as ScrollBehavior })
      }
    }

    setTimeout(() => {
      loaderItem.classList.add('loadend')
      if (this.endFn) this.endFn()
    }, 1000)
  }
}
